import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

export const navbarHeight = "56px"

const useStyles = makeStyles({
	navbarContainer: {
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor()),
		height: navbarHeight,
		flexWrap: "nowrap",
		padding: "0px 22px 0px 22px"
	},
	titleText: {
		fontSize: "15px"
	},
	nameText: {
		textTransform: "uppercase"
	},
	secondaryText: {
		fontWeight: "normal"
	},
	profile: {
		cursor: "pointer"
	},
	logoImg: {
		width: 95
	},
	changeInstanceButtonIcon: {
		color: colors.getPrimaryColor()
	},
	shakeIcon: {
		display: "inline-block",
		animation: "$shakePause 2s infinite"
	},
	"@keyframes shakePause": {
		"0%": { transform: "rotate(0deg)" },
		"10%": { transform: "rotate(-15deg)" },
		"20%": { transform: "rotate(15deg)" },
		"30%": { transform: "rotate(-10deg)" },
		"40%": { transform: "rotate(0deg)" },
		"100%": { transform: "rotate(0deg)" }
	}
})

export default useStyles
